import Client from './Client/AxiosClient'
import { baseUrl } from './Client/AxiosClient'

const resource = `${baseUrl}/api/dashboard/mini-grids`

export default {

    list () {

        return Client.get(`${resource}`)
    },

    update (from = null, to = null, miniGridId = null) {
        const params = new URLSearchParams()
        if (from && to) {
            params.append('from', from)
            params.append('to', to)
        }
        if (miniGridId != null) {
            params.append('miniGridId', miniGridId)
        }
        const query = params.toString()
        return Client.put(`${resource}${query ? '?' + query : ''}`)
    },

    detail (id) {
        return Client.get(`${resource}/${id}`)
    }

}
